import {registerLocaleData} from '@angular/common'
import {provideHttpClient, withInterceptors} from '@angular/common/http'
import localeSvExtra from '@angular/common/locales/extra/sv'
import localeSv from '@angular/common/locales/sv'
import {ApplicationConfig, inject, provideAppInitializer} from '@angular/core'
import {MAT_CARD_CONFIG} from '@angular/material/card'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {provideRouter, Router, withHashLocation} from '@angular/router'
import routes from './app-routes'
import {authInterceptor} from './application/auth.interceptor'
import {ENVIRONMENT, WINDOW} from './application/injection-tokens'
import {routeResolver} from './application/route-resolver'
import {ConfigService} from './services/config.service'
import {environment} from '../environments/environment'
import {responseInterceptor} from '@sparbanken-syd/sparbanken-syd-bankid'

registerLocaleData(localeSv, 'sv', localeSvExtra)


export const appConfig: ApplicationConfig = {
  providers: [
    {provide: WINDOW, useValue: globalThis},
    {provide: MAT_CARD_CONFIG, useValue: {appearance: 'outlined'}},
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        floatLabel: 'always',
        hideRequiredMarker: true,
        appearance: 'outline',
        subscriptSizing: 'dynamic'
      }
    },
    {provide: ENVIRONMENT, useValue: environment},
    /**
     * Conditionally initializes `bootstrap` only for the `/admin` route,
     */
    provideAppInitializer(() => {
      return routeResolver(inject(ConfigService), inject(Router), inject(WINDOW))
    }),
    provideHttpClient(
      withInterceptors([authInterceptor, responseInterceptor])
    ),
    provideRouter(routes,
      withHashLocation())
  ]
}